export default {
    name: 'qrMap',
    title: '位置导航',
    iconSize:43,
    qrList: [{
        icon: 'https://v.2weima.com/static/images/icon/wxmap.png',
        filePath:'',
        text: '新娘家-导航',
        label: '5月20日，接新娘专用',
        qrTitle: '',
        qrScene: ''
    }]
}